var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-img"},[_c('img',{attrs:{"src":_vm.globalObj.other_page_bg.image}})])}
var staticRenderFns = []

export { render, staticRenderFns }